import {BaptismSvg} from "../../../../components/Svgs/BaptismSacramentSvg";
import React from "react";
import {BannsOfMarriage, WeddingRingsSvg} from "../../../../components/Svgs/MatrimonySacramentSvg";
import {TbBellRingingFilled} from "react-icons/tb";
import {SaintsFillSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import {CrossObituarySvg} from "../../../../components/Svgs/CrossBannerSvg";
import {BiSolidFirstAid} from "react-icons/bi";

export const AnnouncementTypes = [
    {value: "ANNOUNCEMENT", label: 'ANNOUNCEMENT', icon: <TbBellRingingFilled size={20} className="text-secondary-700"/>},
    {value: "FINANCIAL_AID", label: 'FINANCIAL_AID', icon: <BiSolidFirstAid size={20} className="text-green-700"/>},
    {value: "OBITUARY", label: 'OBITUARY', icon: <CrossObituarySvg size={20} className="text-gray-900"/>},
    {value: "BAPTISM", label: 'BAPTISM', icon: <BaptismSvg size={20} className="text-blue-500"/>},
    {value: "WEDDING", label: 'WEDDING', icon: <WeddingRingsSvg size={20} className="text-primary"/>},
    {value: "PATRON_FEAST", label: 'PATRON_FEAST', icon: <SaintsFillSvg size={20} className="text-yellow-800"/>},
    {value: "BANNS_OF_MARRIAGE", label: 'BANNS_OF_MARRIAGE', icon: <BannsOfMarriage size={20} className="text-pink-800"/>},
    {value: "OTHER", label: 'OTHER', icon: <TbBellRingingFilled size={20} className="text-color-500"/>},
]